import _ from 'lodash';

export default{
    // SORTING sort-by="sequence" :sort-desc="false"
    totalPageStore(localstorage_name, val){
        if(localStorage.getItem(localstorage_name)){
            let temp = localStorage.getItem(localstorage_name);
            if(val != temp){
                return true;
            }
        }
    },

    params(params, dt_options, dt_itemsPerPage, dt_columns){
        dt_options.itemsPerPage = dt_itemsPerPage;
        const { sortBy, sortDesc, page, itemsPerPage } = dt_options

        let paramsval = params;
        paramsval.rowsPerPage = itemsPerPage;
        paramsval.length = params.rowsPerPage;
        paramsval.start = this.paramStart(params);
        paramsval.search = this.paramSearch(params);
        paramsval.order = this.sortRequest(dt_columns, sortBy, sortDesc);
        paramsval.columns = dt_columns;

        return paramsval;
    },

    paramStart(params){
        return params.page == 1 ? 0 : (params.rowsPerPage * (params.page - 1));
    },

    paramSearch(params){
        return {
            value: params.query,
            regex: false
        };
    },

    setHeader(headers){
        let col = [];
        for (var i = 0; i < headers.length; i++) {
            col[i] = {
                data: headers[i].value,
                name: (typeof(headers[i].name) != 'undefined' ? headers[i].name : headers[i].value),
                searchable: headers[i].searchable,
                orderable: headers[i].sortable,
                search: {
                    value: '',
                    regex: false
                }
            };
        }
        return col;
    },

    sortRequest(headers, sortBy, sortDesc){
        let order = {};
        if (sortBy.length === 1 && sortDesc.length === 1) {
            order = {
                0: {
                    column: _.findIndex(headers, { 'data': sortBy[0] }),
                    dir: (sortDesc[0] ? 'desc' : 'asc')
                }
            };
        }else{
            order = {
                0: {
                    column: 0,
                    dir: 'desc'
                }
            };
        }
        return order;
    },
}